import React from 'react'
import PropTypes from "prop-types"
import { omit, values, sortBy } from 'lodash'
import Button from '../../components/Button'
import { randstr } from '../../../lib/Tools'

import Drink from './Drink'
import "./Carta.less"

const emptyDrink = {
  id : "",
  name : "",
  chName : "",
  description : "",
  price : 0,
  background : { image : null },
  isInMenus: false
}

const DrinksList = ({ drinks, onChange }) => (    
  <div>
    {
      sortBy(values(drinks), "order").map(drink => (
        <Drink
          key={drink.id}
          drink={drink}
          onChange={change => {
            onChange({
              drinks:{
                ...drinks,
                [drink.id]: { ...drinks[drink.id], ...change }
              }
            })
          }}
          onRemove={() => {
            onChange({ drinks: omit(drinks, drink.id) }) 
          }
          }
        />
      ))
    }

    <Button
      glyph="plus"
      onClick={() => {
        const id = randstr(12)
        onChange({ drinks: { ...drinks, [id]: { ...emptyDrink, id } } })
      }}
    >
      Añadir bebida
    </Button>
  </div>
  
)

DrinksList.propTypes = {
  onChange: PropTypes.func.isRequired,
  drinks: PropTypes.object.isRequired,
}

export default DrinksList